// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Xuyd","error":"Textarea_error__2UPCg","readonly":"Textarea_readonly__3wdfb","disabled":"Textarea_disabled__P4dcV"};